'use strict';

export default {
  formPublic: {
    postSubmission: {
      noRecaptcha: 'No recaptcha token were sent to the server',
      invalidRecaptcha: 'The recaptcha token is invalid. Please try again.',
      genericDecline: 'An error occured with the payment. Please try again later',
      insufficientFunds: 'Insufficient funds decline',
      lostCard: 'Lost card decline',
      stolenCard: 'Stolen card decline',
      expiredCard: 'Expired card decline',
      incorrectCVC: 'Incorrect CVC decline',
      processingError: 'Processing error decline',
      incorrectNumber: 'Incorrect number decline',
      missingEmail: 'Invalid/missing customer email for form receipt',
      missingName: 'Missing card holder name',
      genericError: 'An error has occured',
      limitError: 'A product limit has been reached, please try again',
      inactiveFormError: 'The form is inactive. Please contact the organization.',
      incorrectDiscount:
        'An error occured with the discount code. It may have expired or the limit has been reached. It has been removed. Please try again.',
    },
    badges: {
      succeeded: 'Accepted',
      pending: 'Pending',
      failed: 'Failed',
      processing: 'Processing',
      canceled: 'Canceled',
      requiresAction: 'Requires action',
      requiresConfirmation: 'Requires confirmation',
      requiresPaymentMethod: 'Missing payment method',
      refunded: 'Refunded',
      pendingRefund: 'Pending refund',
      ready: 'Planned',
    },
    noFields: 'No Fields',
    submit: 'Submit',
    next: 'Next',
    previous: 'Previous',
    optionalPayment: 'Pay later in another way',
    formFixedAmount: 'Fixed amount for form',
    formAmountSummaryText: 'Basic fee',
    summary: 'Summary',
    shareForm: 'Share this form',
    share: 'Share',
    close: 'Close',
    link: 'URL Link',
    code: 'HTML code',
    copy: 'Copy',
    copied: 'Copied !',
    urlCopy: 'Url copy',
    integrate: 'Integrate',
    open: 'Open in tab',
    receiptEmail: 'Email for form receipt',
    cardHolderName: 'Card Holder Name',
    errorRefundAmount: 'Refund amount must be valid before confirming',
    discountCode: 'Discount Code',
    apply: 'Apply',
    remove: 'Remove',
    discountCodeApplied: `Discount code applied! You save {discount}{type, select, 
                            percent {%}
                            amount {$}
                            other {}  
                          }`,
    discountCodeError: 'The discount code is invalid. Please try again.',
    discount: 'Discount',
    discountCodeSummary: 'Code {code}',
  },
};
